import { Box, Center, Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { AiOutlineArrowLeft, AiOutlineCloseCircle } from "react-icons/ai";

function Toolbar({
  title,
  onBack,
  rightElement,
  onClose,
  border = "2px",
  alignItems,
}: {
  title: string;
  onBack?: () => void;
  rightElement?: React.ReactNode;
  onClose?: () => any;
  border?: string;
  alignItems?: "center" | "flex-start" | "flex-end";
}) {
  return (
    <Box>
      <Box
        borderTopRadius="15px"
        backgroundColor={colors.primary}
        padding="14px"
        borderBottom={border}
        borderBottomColor={colors.orange}
        marginBottom="0px"
      >
        <Flex flexDir="row" gap="10px" alignItems={alignItems}>
          {typeof onBack === "function" ? (
            <Center>
              <AiOutlineArrowLeft
                color="white"
                fontSize="20px"
                onClick={onBack}
                cursor="pointer"
              />
            </Center>
          ) : null}

          <Text fontSize="18px" color="white">
            {title}
          </Text>

          {rightElement}

          {typeof onClose === "function" ? (
            <Center ml="auto">
              <AiOutlineCloseCircle
                color="white"
                fontSize="28px"
                onClick={onClose}
                cursor="pointer"
              />
            </Center>
          ) : null}
        </Flex>
      </Box>
    </Box>
  );
}

export default Toolbar;
